module.exports = __webpack_public_path__ + "Sergio_Regueros_Web_Over.jpg?81a1b97636e379cd0175a3dbc5d706fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Sergio_Regueros_Web_Over.jpg
// module id = 172
// module chunks = 0